import humps from 'lodash-humps-ts';
import axios from 'axios';
import { authAxios } from '@components/Auth';
import { HealthPlan } from '@models/HealthPlan';
import { API_V1_BASE } from '@config';

export class HealthPlanApi {
  static getAll = async () => {
    return await authAxios.get(`${API_V1_BASE}/health_plans`).then((response) => humps(response.data) as HealthPlan[]);
  };

  static getPublic = async () => {
    return await axios.get(`${API_V1_BASE}/health_plans/public`).then((response) => humps(response.data) as HealthPlan[]);
  };
}
